import {helpUrlLocalizer} from 'utilities/i18n/url-localizer';

/**
 * This maps the stepHandle to the configuration required
 * to render footer help when the user loads that particular step.
 */
export const StepsFooterHelp = {
  category: {
    about: 'hiring an expert',
    url: helpUrlLocalizer('manual/community/experts'),
  },

  marketing: {
    about: 'marketing your store',
    url: helpUrlLocalizer('manual/promoting-marketing'),
  },

  submission: {
    about: 'hiring an expert',
    url: helpUrlLocalizer('manual/community/experts'),
  },
};
